import { FormGroup } from '@angular/forms';
import { Component } from '@angular/core';
import {
  RxFormBuilder,
  ReactiveFormConfig,
} from '@rxweb/reactive-form-validators';

import { AuthService } from '@monorepo/ui/auth';
import { NotifyAlertService, Error } from '@monorepo/ui';
import { LoginService } from '../../services/login.service';

import { LoginViewEnum } from '../login-view.enum';
import { UserRegistration } from '../../models';

@Component({
  selector: 'signgaze-registration',
  templateUrl: './registration.component.html',
  styleUrls: ['./registration.component.scss'],
})
export class RegistrationComponent {
  loginViewEnum: any = LoginViewEnum;
  registrationForm: FormGroup;
  isConfirmToTermsAndConditions = false;
  isSubmitted = false;

  constructor(
    private authService: AuthService,
    private loginService: LoginService,
    private rxFb: RxFormBuilder,
    private notifyAlertService: NotifyAlertService
  ) {
    this.setFormErrorMessage();
    this.createRegistrationForm();
  }

  private createRegistrationForm(): void {
    this.registrationForm = this.rxFb.formGroup(UserRegistration);
  }

  private setFormErrorMessage(): void {
    ReactiveFormConfig.set({
      validationMessage: {
        password:
          'Password must contain be atleast 5 characters including 1 digit & special characters',
        compare: 'Passwords should match',
      },
    });
  }

  public changeLoginView(currentLoginView: LoginViewEnum): void {
    this.loginService.currentLoginView$.next(currentLoginView);
  }

  public getPasswordInput(passwordInput: any): void {
    switch (passwordInput.type) {
      case 'password':
        passwordInput.type = 'text';
        break;
      default:
        passwordInput.type = 'password';
        break;
    }
  }

  public registerUser(): void {
    this.isSubmitted = true;
    this.authService
      .emailSignUp(this.registrationForm.value)
      .then(() => {
        this.isSubmitted = false;
        this.registrationForm.reset();
        this.loginService.changeLoginView(this.loginViewEnum.LOGIN);
      })
      .catch((error) => {
        this.isSubmitted = false;
        this.notifyAlertService.error(Error[error.code] || error.message);
      });
  }
}
